<template>
	<div>
		<Breadcrumbs main="" title=""/>
		<div class="container-fluid">
            <div class="col-sm-12">
                <div v-show="process === 'add'" class="col-sm-12" id="addDriver">
                    <div class="row ml-1" v-b-hover="handleHover">
                        <h2 class="text-primary mt-3">{{ $t('driver.addDriver') }}</h2> 
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                        <span v-show="isHovered" class="text-danger">{{ $t('driver.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form col-sm-6">
                        <div class="row col-sm-12">
                            <div class="form-group col-sm-3">
                                <h4  style="font-size: 16px;" >{{ $t("driver.name") }}</h4>
                                <input type="text" id="name" v-model="name" :placeholder="$t('driver.namePh')">
                            </div>                                                                  
                            <div class="form-group col-sm-3">
                                <h4 style="font-size: 16px;" >{{ $t("driver.phone") }}</h4>
                                <input type="number" id="phone" v-model="phone" :placeholder="$t('driver.phonePh')">
                            </div>   
                            <div class="form-group col-sm-3">
                                <h4  style="font-size: 16px;" >{{ $t('register.email') }}</h4>
                                <input type="email" id="email" v-model="email" :placeholder="$t('register.emailPh')">
                            </div>                            
                        </div>             
                        <div class="row col-sm-12">
                            <div class="form-group col-sm-6">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.driverLicenseNo") }}</h4>                                                 
                                <input type="text" id="driverLicenseNo" v-model="driverLicenseNo" class="form-control" :placeholder="$t('driver.driverLicenseNoPh')" >
                            </div>
                                <div class="form-group col-sm-6">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.licenseExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :placeholder="$t('driver.licenseExpiryDatePh')"
                                    :language="th"                                    
                                    v-model="licenseExpiryDate" >
                                </datepicker>
                            </div>                                        
                        </div>          
                        <div class="form-group col-sm-12">
                            <button class="btn btn-primary btn-block" style="font-size:20px"  type="button" @click="handleSave">{{ $t('bookingId.saveAdd') }}</button>
                        </div>
                    </form>                                 
                </div>
                <div v-show="process === 'update'" class="col-sm-12" id="editDriver">
                    <div class="row ml-1" v-b-hover="handleHoverEdit">
                        <h4 class="text-danger mt-3">{{ $t('driver.editDriver') }}</h4> 
                        <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="process = 'info' ">&times;</span>
                        <span v-show="isHoveredEdit" class="text-danger">{{ $t('driver.cancelReturn')  }} </span>
                    </div>
                    <form class="theme-form col-sm-6">
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.driverId") }}</h4>                                                 
                                <input type="text" id="editDriverId" v-model="editDriverId" disabled class="form-control" >
                            </div>  
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.driverLicenseNo") }}</h4>                                                 
                                <input type="text" id="editDriverLicenseNo" v-model="editDriverLicenseNo" required class="form-control" :placeholder="$t('driver.driverLicenseNoPh')" >
                            </div>
                                <div class="form-group col-sm-4">
                                <h4  class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.licenseExpiryDate") }}</h4>
                                <datepicker 
                                    input-class="datepicker-here form-control digits"  
                                    :disabled-dates="disabledDates"  
                                    :format="format" 
                                    :placeholder="$t('driver.licenseExpiryDatePh')"
                                    :language="th"
                                    v-model="editLicenseExpiryDate" >
                                </datepicker>
                            </div>                                      

                        </div>
                        <div class="row">
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.name") }}</h4>                                                 
                                <input type="text" id="editName" v-model="editName" required class="form-control" :placeholder="$t('driver.namePh')" >
                            </div>                               
                            <div class="form-group col-sm-4">
                                <h4 class="col-form-label pt-0 f-w-600 " style="font-size: 16px;" >{{ $t("driver.phone") }}</h4>
                                <input type="number" id="editPhone" v-model="editPhone" required :placeholder="$t('driver.phonePh')">
                            </div>                                                                
                        </div>                        
                        <div class="form-group">
                            <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('driver.saveEdit') }}</button>
                        </div>
                    </form>                                 
                </div> 
                <b-modal id="driverInfo" header-text-variant="primary" :title="$t('driver.driverInfo')" ok-only @hide="resetInfoModalDriverInfo">
                    <div class="card me-5" style=" width:30rem">
                        <div class="row ml-2 mt-2"> 
                            <h5 class="text-primary"> {{ $t('driver.name') }} :</h5> 
                            <span class="ml-3 text-info"> {{ driverInfo.name }}</span>                  
                        </div>
                        <div class=" row ml-2 mt-2"> 
                            <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                            <span class="ml-3 text-info"> {{ driverInfo.phone }}</span>                  
                        </div>                        
                        <div class=" row ml-2 mt-2"> 
                            <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                            <span class="ml-3 text-info"> {{ driverInfo.email }}</span>                  
                        </div>
                    </div>
                </b-modal>
                <div class="col-sm-6">
                    <div class="row ml-1">
                        <h2 class="text-primary mt-1">{{ $t('driver.driverList') }}</h2>   
                        <b-button v-show="process === 'info'" pill href="#addDriver" size="sm" @click="process = 'add' " class="bg-primary mb-4 mx-3 ">
                            <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('driver.addDriver') }} </span>
                        </b-button>                         
                    </div>
                    <div class="row ">
                        <b-col lg="6" class="my-1">
                            <b-form-group
                            :label="$t('matchTx.filter')"
                            label-for="filter-input"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            >
                                <b-input-group size="sm">
                                    <b-form-input
                                    id="filter-input"
                                    v-model="filter"
                                    type="search"
                                    :placeholder="$t('matchTx.typeToSearch')"
                                    class="text-info"
                                    style="font-size: 18px;"
                                    ></b-form-input>
                                    <b-input-group-append>
                                    <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                        {{ $t('matchTx.clear') }}
                                    </b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>                            
                        <b-col lg="6" class="my-1">
                            <b-form-group
                            v-model="sortDirection"
                            :label="$t('matchTx.filterOn')"
                            :description= "$t('matchTx.uncheck')"
                            label-cols-sm="3"
                            label-align-sm="right"
                            label-size="lg"
                            class="mb-0"
                            v-slot="{ ariaDescribedby }"
                            >
                            <b-form-checkbox-group
                                v-model="filterOn"
                                :aria-describedby="ariaDescribedby"
                                class="mt-1 text-info"
                                plain
                            >
                                <b-form-checkbox value="driverLicenseNo">{{ $t('driver.driverLicenseNo') }}</b-form-checkbox>                                        
                                <b-form-checkbox value="driverId">{{ $t('driver.driverId') }}</b-form-checkbox>
                            </b-form-checkbox-group>
                            </b-form-group>
                        </b-col>                          
                    </div>          
                    <b-row class="ml-2">
                        <b-table
                            sticky-header
                            head-variant="light"
                            table-variant="success"
                            show-empty
                            sort-icon-left
                            stacked="md"
                            :sort-direction="sortDirection"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            :items="items"
                            :fields="fields"
                            :tbody-tr-class="rowClass"
                            :current-page="currentPage"
                            :per-page="perPage"
                            @filtered="onFiltered"
                        >
                            <template #cell(index)="data">
                                {{ data.index + 1 }}
                            </template>
                            <template #cell(driverInfo)="row" >
                                <b-button  size="md" @click="openModalDriverInfo(row.item, row.index, $event.target )" class="m-1">
                                    {{ row.item.driverId }}
                                </b-button>
                            </template>
                            <template #cell(act)="row" >
                                <b-button  v-show="row.item.active"  size="sm" variant="danger" @click="actStop(row.item)" class="m-1">
                                    {{ $t('driver.stoped') }}
                                </b-button>
                                <b-button  v-show="!row.item.active" size="sm" variant="success" @click="actAble(row.item)" class="m-1">
                                    {{ $t('driver.abled') }}
                                </b-button>
                                <b-button  size="sm" variant="warning" @click="actUpdate(row.item)" class="m-1">
                                    {{ $t('container.update')  }}
                                </b-button>                                
                            </template>
                            <template #empty>
                                <h5>{{ $t('reuse.noRecord') }}</h5>
                            </template>
                        </b-table>  
                    </b-row>
                    <b-row>
                        <b-col class="my-1 ml-1">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="fill"
                            class="my-0"
                            ></b-pagination>
                        </b-col>   
                        <b-col sm="3" md="6" class="my-1">
                            <b-form-group
                            :label= "$t('require.perPage')"
                            label-for="per-page-select"
                            label-cols-sm="6"
                            label-cols-md="4"
                            label-cols-lg="3"
                            label-align-sm="right"
                            label-size="sm"
                            class="mb-0"
                            >
                            <b-form-select
                                id="per-page-select"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>               
                </div>               
            </div>
        </div>
    </div>
</template>
<script>
import { createUserWithEmailAndPassword } from 'firebase/auth'
import {authUser , updateActive , saveWithId, mergeObj, getData} from "../../firebase"
import {en, th} from 'vuejs-datepicker/dist/locale'
export default {
	data(){
		return{
            en: en,
            th: th,
            process : "info",
            isHovered: false,
            isHoveredEdit: false,
            driverInfo : '',
            driverId: '',  // = userId , no change
            driverLicenseNo: '',
            licenseExpiryDate: '',       
            userId: '',
            name: '',
            phone: '',
            email: '',
            // password: '',  use phone numbeer as defualt for startup driver.
            active: true, // Default to active
            compId : '',
            disabledDates: {
                to: new Date(),
            },
            format: "yyyy-MM-dd",
            editDriverId: '',
            editDriverLicenseNo: '',
            editLicenseExpiryDate: '',
            editName: '',
            editPhone: '',
            editActive: true,
            items: [],
            fields: [
                { key: 'driverInfo', label: this.$t('driver.driverId'),variant: 'secondary', sortable: true, }, 
                { key: 'driverLicenseNo', label: this.$t('driver.driverLicenseNo'), variant: 'primary', sortable: true, },                  
                { key: 'licenseExpiryDate', label: this.$t('driver.licenseExpiryDate'), variant: 'primary', sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YYYY")
                }},           
                { key: 'recordAt', label: this.$t('driver.recordAt'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YYYY")
                }},                
                { key: 'active', label: this.$t('driver.active'), variant: 'primary',sortable: true,
                    formatter: value => {
                        return this.$t(`driver.${value}`)
                }},                
                { key: 'act', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
		}
	},

    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
	mounted(){
        this.compId= localStorage.getItem("compId")
        getData( "Driver", 'compId', this.compId, (res)=>{
            this.items = res
            this.totalRows = res.length
        })
	},
	methods:{
        handleHover(hovered) {
            this.isHovered = hovered
        },
        handleHoverEdit(hovered) {
            this.isHoveredEdit = hovered
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.active === false) return 'table-danger'
        },
        async doSave(){
            let payload = {
                driverId : this.driverId,
                driverLicenseNo: this.driverLicenseNo,
                licenseExpiryDate: Date.parse(this.licenseExpiryDate),      
                currentLoc : '',
                active: true, // Default to active
                compId : this.compId,       
                recordAt: Date.parse(new Date()),
            }
            await saveWithId('Driver', this.driverId, payload)
            await this.refresh()
            this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});    
        },
        async handleSave(){
            const tenDigitPhoneRegex = /^\d{10}$/;
            let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            let password = `${this.phone}`
            let msg = 'completed'
            if (this.driverLicenseNo ==='') {
                msg = 'driver.addDriverLicenseNo'
            } else if (this.licenseExpiryDate === ''){
                msg = 'driver.addLicenseExpiryDate'
            } else if (this.name===''){
                msg = 'driver.name'
            } else if (this.phone === ''){
                msg = 'driver.addPhone'
            } else if (!tenDigitPhoneRegex.test(this.phone)){
                msg = 'driver.tenDigitPhoneRegexFormatMsg'
            } else if (this.email ===''){
                msg = 'driver.addEmail'
            } else if (!emailRegex.test(this.email)){
                msg = 'driver.verifyEmail'
            }  
            if (msg === 'completed'){
                createUserWithEmailAndPassword(authUser, this.email, password)  // use phone number as default password for startup driver.
                .then( async(userCredential) => {
                    if (userCredential) {
                    let userId = `${Math.floor(Math.random() * (9000000 - 1000000 + 1) + 1000000)}`
                    this.driverId = userId
                    let payload = {
                        uid: userCredential.user.uid,
                        userId : userId,
                        name: this.name,
                        phone: this.phone,
                        userCat: 'driver',
                        compId: this.compId,
                        email: this.email,
                        active: true,
                    }
                    await saveWithId('Users', userId, payload)
                    await this.doSave()
                    }
                })
                .catch((error) => {
                    this.$toasted.show('Error...' + error.message, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                });
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async doUpdate(){
            let payload = {
                driverId : this.editDriverId,
                driverLicenseNo: this.editDriverLicenseNo,
                licenseExpiryDate: Date.parse(this.editLicenseExpiryDate),
                currentLoc : '',
                active: this.editActive, // Default to active
                compId : this.compId,       
                recordAt: Date.parse(new Date()),
            }
            await saveWithId('Driver', this.editDriverId, payload)
            
        },
        async handleUpdate(){
            const tenDigitPhoneRegex = /^\d{10}$/;
            let msg = 'completed'
            if (this.editDriverLicenseNo ==='') {
                msg = 'driver.addDriverLicenseNo'
            } else if (this.editLicenseExpiryDate === ''){
                msg = 'driver.addLicenseExpiryDate'
            } else if (this.editName ===''){
                msg = 'driver.addName'
            } else if (this.editPhone === ''){
                msg = 'driver.addPhone'
            } else if (!tenDigitPhoneRegex.test(this.editPhone)){
                msg = this.$t('driver.tenDigitPhoneRegexFormatMsg')
            }  
            if (msg === 'completed'){
                await this.doUpdate()                
                let obj = {
                    name: this.editName,
                    phone: this.editPhone,
                }
                console.log(`obj =>${JSON.stringify(obj , null , 2)}`)
                await mergeObj('Users', this.editDriverId, obj).then(async()=>{
                    await this.refreshEdit()
                    this.process = 'info'
                    this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'top-center', type: 'success' , duration: 5000});                                                    
                })  

            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async actUpdate(item) {
            this.editDriverId = item.driverId
            this.editDriverLicenseNo = item.driverLicenseNo
            this.editLicenseExpiryDate = this.$moment(item.licenseExpiryDate ).format("YYYY-MM-DD") 
            this.editActive = item.active
            await getData('Users', 'userId',item.driverId , (res)=>{
                console.log(`GetData, User Info => ${JSON.stringify(res , null , 2)}`)
                this.editName= res[0].name
                this.editPhone= res[0].phone
            })
            this.process = "update"   // to pop up Update subMenu
        }, 
        actStop(item) {
            this.$bvModal.msgBoxConfirm(this.$t('bookingId.confirmStopMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await updateActive( "Driver", item.driverId, false)
                    await this.refresh()                    
                    this.$toasted.show( this.$t('driver.stoped'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Suspend: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },
        actAble(item) {
            this.$bvModal.msgBoxConfirm(this.$t('bookingId.confirmAbleMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await updateActive( "Driver", item.driverId , true)
                     this.refresh()                    
                    this.$toasted.show( this.$t('driver.abled'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});  
                } else {
                return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    

        async openModalDriverInfo(item, index, button) {
            await getData('Users', 'userId',item.driverId , (res)=>{
            this.driverInfo = res[0]
            })
            this.$root.$emit('bv::show::modal', "driverInfo" , button)
        },
        resetInfoModalDriverInfo() {
            this.driverInfo = ''
        },  
        async refresh(){
            await getData( "Driver",'compId' ,this.compId, (res)=>{
                this.items = res
                this.totalRows = res.length
                this.driverLicenseNo = ''
                this.licenseExpiryDate = ''                   
                this.name = ''
                this.phone = ''
            })
        },
        async refreshEdit(){
            await getData( "Driver",'compId' ,this.compId, (res)=>{
                this.items = res
                this.totalRows = res.length
                this.editDriverLicenseNo = ''
                this.editLicenseExpiryDate = ''                   
                this.editName = ''
                this.editPhone = ''
            })
        },
    }
}
</script>
<style scoped>

</style>

